import { useState } from 'react';
import axios from 'axios';
import Layout from '../components/Layout';

import {
  FaUsers,
  FaCheckCircle,
  FaTimesCircle,
  FaSave,
  FaBell
} from 'react-icons/fa';

function Attendance() {

  const [className, setClassName] = useState('');
  const [sectionName, setSectionName] = useState('');
  const [students, setStudents] = useState([]);

  const loadStudents = () => {

    if (!className || !sectionName) {

      alert('Please Select Class and Section');

      return;

    }

    axios.get(
      `${process.env.REACT_APP_API_URL}/attendance/${className}/${sectionName}`
    )
    .then((res) => {

      const attendanceData = res.data.map(
        (student) => ({
          ...student,
          status: 'Present'
        })
      );

      setStudents(attendanceData);

    })
    .catch((err) => {

      console.log(err);

      alert('Failed To Load Students');

    });

  };

  const updateStatus = (index, status) => {

    const updatedStudents = [...students];

    updatedStudents[index].status = status;

    setStudents(updatedStudents);

  };

  const saveAttendance = () => {

    const today =
      new Date().toISOString().split('T')[0];

    const attendanceData = students.map(
      (student) => ({
        student_id: student.id,
        attendance_date: today,
        status: student.status
      })
    );

    axios.post(
      `${process.env.REACT_APP_API_URL}/attendance`,
      attendanceData
    )
    .then((res) => {

      alert(res.data.message);

    })
    .catch((err) => {

      console.log(err);

      alert('Error Saving Attendance');

    });

  };

  const sendAbsentSMS = () => {

    axios.post(
      `${process.env.REACT_APP_API_URL}/send-absent-sms`
    )
    .then((res) => {

      alert(
        res.data.message ||
        `${res.data.count || 0} Notification Sent`
      );

    })
    .catch((err) => {

      console.log(err);

      alert('Notification Failed');

    });

  };

  const totalPresent =
    students.filter(
      s => s.status === 'Present'
    ).length;

  const totalAbsent =
    students.filter(
      s => s.status === 'Absent'
    ).length;

  return (

    <Layout>

      <div className="container-fluid">

        <div className="mb-4">

          <h1
            style={{
              fontWeight: '800',
              color: '#0f172a'
            }}
          >
            Attendance Management
          </h1>

          <p
            style={{
              color: '#64748b'
            }}
          >
            Manage daily attendance records
          </p>

        </div>

        {/* FILTER CARD */}

        <div
          className="card p-4 mb-4"
          style={{
            borderRadius: '24px'
          }}
        >

          <h4 className="mb-4">
            Select Class & Section
          </h4>

          <div className="row">

            <div className="col-md-6">

              <select
                className="form-control"
                value={className}
                onChange={(e) =>
                  setClassName(
                    e.target.value
                  )
                }
              >

                <option value="">
                  Select Class
                </option>

                <option>1</option>
                <option>2</option>
                <option>3</option>
                <option>4</option>
                <option>5</option>
                <option>6</option>
                <option>7</option>
                <option>8</option>
                <option>9</option>
                <option>10</option>

              </select>

            </div>

            <div className="col-md-6">

              <select
                className="form-control"
                value={sectionName}
                onChange={(e) =>
                  setSectionName(
                    e.target.value
                  )
                }
              >

                <option value="">
                  Select Section
                </option>

                <option>A</option>
                <option>B</option>
                <option>C</option>

              </select>

            </div>

          </div>

          <button
            className="btn btn-primary mt-4"
            onClick={loadStudents}
          >
            <FaUsers /> Load Students
          </button>

        </div>

        {/* SUMMARY */}

        {students.length > 0 && (

          <>

            <div className="row mb-4">

              <div className="col-md-6">

                <div
                  className="card p-4"
                  style={{
                    borderRadius: '20px',
                    background:
                      'linear-gradient(135deg,#10b981,#22c55e)',
                    color: '#fff'
                  }}
                >

                  <h5>
                    Present Students
                  </h5>

                  <h2>
                    {totalPresent}
                  </h2>

                </div>

              </div>

              <div className="col-md-6">

                <div
                  className="card p-4"
                  style={{
                    borderRadius: '20px',
                    background:
                      'linear-gradient(135deg,#ef4444,#f87171)',
                    color: '#fff'
                  }}
                >

                  <h5>
                    Absent Students
                  </h5>

                  <h2>
                    {totalAbsent}
                  </h2>

                </div>

              </div>

            </div>

            {/* TABLE */}

            <div
              className="card p-4"
              style={{
                borderRadius: '24px'
              }}
            >

              <h4 className="mb-4">
                Student Attendance
              </h4>

              <div className="table-responsive">

                <table className="table">

                  <thead>

                    <tr
                      style={{
                        background:
                          '#eef2ff'
                      }}
                    >

                      <th>ID</th>
                      <th>Name</th>
                      <th>Present</th>
                      <th>Absent</th>

                    </tr>

                  </thead>

                  <tbody>

                    {students.map(
                      (student, index) => (

                        <tr
                          key={student.id}
                        >

                          <td>
                            {student.id}
                          </td>

                          <td>
                            {
                              student.student_name
                            }
                          </td>

                          <td>

                            <button
                              className={
                                student.status ===
                                'Present'
                                  ? 'btn btn-success btn-sm'
                                  : 'btn btn-outline-success btn-sm'
                              }
                              onClick={() =>
                                updateStatus(
                                  index,
                                  'Present'
                                )
                              }
                            >
                              <FaCheckCircle />
                            </button>

                          </td>

                          <td>

                            <button
                              className={
                                student.status ===
                                'Absent'
                                  ? 'btn btn-danger btn-sm'
                                  : 'btn btn-outline-danger btn-sm'
                              }
                              onClick={() =>
                                updateStatus(
                                  index,
                                  'Absent'
                                )
                              }
                            >
                              <FaTimesCircle />
                            </button>

                          </td>

                        </tr>

                      )
                    )}

                  </tbody>

                </table>

              </div>

              <div className="mt-4">

                <button
                  className="btn btn-success"
                  onClick={saveAttendance}
                >
                  <FaSave /> Save Attendance
                </button>

                <button
                  className="btn btn-danger ms-2"
                  onClick={sendAbsentSMS}
                >
                  <FaBell /> Send Notification
                </button>

              </div>

            </div>

          </>

        )}

      </div>

    </Layout>

  );

}

export default Attendance;